import { IProject, speciesModelCodeFor, speciesDefaultsFor } from "./types/IProject";
import { IStructure } from "./types/IStructure";
import { IArea, startDayFor } from './types/IArea';
import { AreaGridUtils } from './util/AreaGridUtils';
import { AquaFishFacade } from './c/AquaFishFacade';
import { IDriverset } from './api/models';
import { ISpecies } from './api/models/ISpecies';
import { IOrganixGridPoint } from './types/IOrganixGridPoint';
import { IOrganixInput } from './types/IOrganixInput';

/**
 * Exports a calculated area grid to JSON.
 */
class GridExporterJSON {

  static run = async (project: IProject, driverset: IDriverset, area: IArea, modelCode: number, structures: IStructure[], data: IOrganixGridPoint[], species: ISpecies[] = []): Promise<IOrganixInput> => {
    const width_meters = AreaGridUtils.width(area.rect);
    const height_meters = AreaGridUtils.height(area.rect);
    const horizontal_resolution = area.resolution;
    const vertical_resolution = AreaGridUtils.verticalResolution(area.rect, area.resolution);

    // One code drives both the growth run and the metadata ORGANIX receives.
    const speciesCode = speciesModelCodeFor(project);

    const aquafishResult = await AquaFishFacade.call(
      { startTime: startDayFor(area.startMonth), endTime: area.days - 1, species: speciesCode,
        // null leaves the facade on its own default, as before this column existed.
        initialWeight: speciesDefaultsFor(project, species).initialWeight ?? undefined },
      driverset)

    const input: IOrganixInput = {
      metadata: {
        farmName: project.name,
        species: speciesCode,
        matrixWidth: horizontal_resolution,
        matrixHeight: vertical_resolution,
        cellWidth: width_meters / horizontal_resolution,
        cellHeight: height_meters / vertical_resolution,
        structures: structures.length,
        stocking: parseInt(project.stocking as any),
        cultureDays: area.days,
        structureDepth: area.structureDepth,
        feedPelletDiameter: area.feedPelletDiameter,
        faecesDiameter: area.faecesDiameter,
        xDispersion: area.xDispersion,
        yDispersion: area.yDispersion
      },
      grid: data,
      structures: structures.map((s, i) => ({ id: i + 1, name: s.name, stocking: parseInt(s.stocking as any) })),
      loads: {
        wasteFeedLoad: aquafishResult.days.map(d => d.wasteFeed),
        faecesLoad: aquafishResult.days.map(d => d.faecesElimination)
      },
      solver: {
        solver: area.solver,
        timestepReductionFactor: area.timestepReductionFactor,
        adamsBashforthIterations: 1,
        turbulenceCoefficient: 1.0,
        modelCode: modelCode
      }
    }

    return input;
  }
}

export { GridExporterJSON }
